import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Integrations = () => {
  const { t } = useLanguage();
  
  return (
    <section className="bg-[#0a0a0b] py-20">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-teal-400/10 text-teal-400 text-sm font-medium px-4 py-1.5 rounded-full">
            {t('integrations.ecosystem') || 'Ecosystem'}
          </span>
          <h2 className="text-3xl md:text-4xl font-semibold text-white mt-6">
            {t('integrations.title') || 'Integrations and Partners'}
          </h2>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto">
            {t('integrations.subtitle') || 'Connect with your favorite tools and platforms. Powered by industry-leading technologies and partnerships.'}
          </p>
        </div>

        {/* Integration Image */}
        <div className="relative rounded-2xl overflow-hidden border border-gray-800">
          <div className="bg-gradient-to-br from-[#0d1117] via-[#1a1a1f] to-[#0d1117] p-8 md:p-16">
            {/* Integration Grid */}
            <div className="grid grid-cols-3 md:grid-cols-5 gap-6 md:gap-8">
              {/* Row 1 */}
              <IntegrationCard name="n8n" color="#EA4B71" />
              <IntegrationCard name="Slack" color="#4A154B" icon="slack" />
              <IntegrationCard name="Twilio" color="#F22F46" />
              <IntegrationCard name="Make" color="#9747FF" />
              <IntegrationCard name="Google" color="#4285F4" icon="google" />
              
              {/* Row 2 */}
              <IntegrationCard name="Zapier" color="#FF4F00" />
              <IntegrationCard name="HubSpot" color="#FF7A59" />
              <div className="col-span-1 flex items-center justify-center">
                <div className="w-16 h-16 md:w-20 md:h-20 bg-teal-400/20 rounded-full flex items-center justify-center">
                  <span className="text-teal-400 font-bold text-lg">OD</span>
                </div>
              </div>
              <IntegrationCard name="Salesforce" color="#00A1E0" />
              <IntegrationCard name="Zoho" color="#E42527" />
              
              {/* Row 3 */}
              <IntegrationCard name="OpenAI" color="#00A67E" />
              <IntegrationCard name="Azure" color="#0089D6" />
              <IntegrationCard name="AWS" color="#FF9900" />
              <IntegrationCard name="GCP" color="#4285F4" />
              <IntegrationCard name="Sheets" color="#0F9D58" icon="sheets" />
            </div>

            {/* Connection Lines - Decorative */}
            <div className="absolute inset-0 pointer-events-none">
              <svg className="w-full h-full opacity-10" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                    <circle cx="20" cy="20" r="1" fill="#1EC6B6" />
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#grid)" />
              </svg>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-8">
          <a
            href="/integrations"
            className="inline-flex items-center gap-2 text-teal-400 hover:text-teal-300 transition-colors"
          >
            Learn More About Integrations
            <span>→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

const IntegrationCard = ({ name, color, icon }) => {
  return (
    <div className="group relative">
      <div 
        className="w-12 h-12 md:w-16 md:h-16 mx-auto rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 border border-gray-800 bg-[#1a1a1f]"
        style={{ boxShadow: `0 0 20px ${color}20` }}
      >
        <span className="text-white text-xs md:text-sm font-medium">
          {name.slice(0, 2).toUpperCase()}
        </span>
      </div>
      <p className="text-gray-500 text-xs mt-2 text-center opacity-0 group-hover:opacity-100 transition-opacity">
        {name}
      </p>
    </div>
  );
};

export default Integrations;
